(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gntl-collection"] && !Shopify.designMode) return;
  try {
    
function setupGntlFilters(){
  document.querySelectorAll('[id^="GntlCollection-"]').forEach(root=>{
    if(root.dataset.initialized)return;root.dataset.initialized='true';
    const form=root.querySelector('form'),grid=root.querySelector('[data-gntl-grid]'),cards=Array.from(grid.querySelectorAll('[data-gntl-card]'));
    const get=n=>form.querySelector('[data-gntl-filter="'+n+'"]').value;
    function update(){let count=0;cards.forEach(card=>{const sizes=card.dataset.sizes.split(',').map(s=>s.trim().split(' / ').pop());const visible=(!get('size')||sizes.includes(get('size')))&&(!get('colour')||card.dataset.title.includes(get('colour')))&&(!get('fit')||card.dataset.fit===get('fit'))&&(!get('stock')||card.dataset.stock==='true')&&(!get('max')||Number(card.dataset.price)<=Number(get('max'))*100);card.hidden=!visible;if(visible)count++;});
      cards.sort((a,b)=>get('sort')==='price-low'?a.dataset.price-b.dataset.price:get('sort')==='price-high'?b.dataset.price-a.dataset.price:Number(b.dataset.stock==='true')-Number(a.dataset.stock==='true')).forEach(c=>grid.appendChild(c));
      root.querySelector('[data-gntl-count]').textContent=count+' / '+cards.length;
    }
    form.addEventListener('input',update);form.addEventListener('change',update);form.addEventListener('reset',()=>requestAnimationFrame(update));update();
  });
}
setupGntlFilters();document.addEventListener('shopify:section:load',setupGntlFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
